import React, { useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import supabase from '../supabase/supabase';
import { incrementScanCount } from '../services/qrService';
import NotFound from '../components/NotFound';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiLoader } = FiIcons;

const RedirectPage = () => {
  const { slug } = useParams();
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);

  useLayoutEffect(() => {
    const performRedirect = async () => {
      if (!slug) {
        setNotFound(true);
        return;
      }

      try {
        // 1. Fetch the destination URL
        const { data, error: fetchError } = await supabase
          .from('qrcodes')
          .select('id, destination_url')
          .eq('slug', slug)
          .single();

        if (fetchError || !data || !data.destination_url) {
          console.error('QR Code not found or error:', fetchError);
          setNotFound(true);
          return;
        }

        // 2. Increment scan count using the RPC function
        await incrementScanCount(data.id);

        // 3. Format URL and Redirect
        let destUrl = data.destination_url.trim();
        if (!/^https?:\/\//i.test(destUrl)) {
          destUrl = `https://${destUrl}`;
        }

        // 302-like behavior using location.replace
        window.location.replace(destUrl);
      } catch (err) {
        console.error('Redirect Exception:', err);
        setNotFound(true);
      }
    };

    performRedirect();
  }, [slug]);

  // If slug is not found in database, show the brutalist 404 page
  if (notFound) {
    return <NotFound />;
  }

  // Loading state (visible for only a few milliseconds)
  return (
    <div className="fixed inset-0 bg-[#f4f4f4] flex flex-col items-center justify-center">
      <div className="bg-white border-[4px] border-black p-8 brutal-shadow flex flex-col items-center">
        <SafeIcon icon={FiLoader} className="w-12 h-12 text-black animate-spin mb-4" />
        <p className="font-black uppercase tracking-widest text-sm">Validating Link...</p>
      </div>
    </div>
  );
};

export default RedirectPage;